/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCampaignMetadata} from '../api'

 export const useQueryGetCampaignMetadata = createReactQueryHook('getCampaignMetadata', getCampaignMetadata)
